var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.332,
    height: 27,
    viewBox: "0 0 28.332 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2014",
    "data-name": "Groupe 2014",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2013",
    "data-name": "Groupe 2013"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-edit",
    "data-name": "Icon material-edit",
    d: "M4.5,24.767V30.1h5.624L26.712,14.37,21.088,9.037,5.279,24.028ZM31.061,10.246a1.365,1.365,0,0,0,0-2.005l-3.51-3.328a1.552,1.552,0,0,0-2.115,0l-2.745,2.6,5.624,5.333,2.745-2.6Z",
    transform: "translate(-3.168 -4.496)",
    fill: "#f0dbd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-edit-2",
    "data-name": "Icon material-edit",
    d: "M31.061,9.6a1.122,1.122,0,0,0,0-1.78l-3.51-2.953a1.7,1.7,0,0,0-2.115,0l-2.745,2.31,5.624,4.733Z",
    transform: "translate(-3.168 -4.496)",
    fill: "#f77fb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-edit-3",
    "data-name": "Icon material-edit",
    d: "M4.5,24.83,10.124,30.1,26.712,14.555,21.088,9.284Z",
    transform: "translate(-3.168 -4.496)",
    fill: "#fba744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-edit-4",
    "data-name": "Icon material-edit",
    d: "M-.018,5.473,1.274,7.158,5.929,1.618,4.654-.019Z",
    transform: "matrix(0.017, 1, -1, 0.017, 25.028, 3.088)",
    fill: "#d0d0d0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_153",
    "data-name": "Trac\\xE9 153",
    d: "M1.6,0,2.909,2.148,0,1.784Z",
    transform: "translate(2.261 27) rotate(-141)",
    fill: "#707070"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.73f9a9300ce9d04e495f491b801ee8a0.svg";
export { ForwardRef as ReactComponent };